var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14570_89911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2452 7.74799V11.0813M10.2452 14.4147H10.2536M9.09134 3.4911L2.23727 15.3299C1.85709 15.9866 1.66701 16.3149 1.6951 16.5844C1.71961 16.8194 1.84275 17.033 2.03388 17.172C2.25301 17.3313 2.6324 17.3313 3.39117 17.3313H17.0993C17.8581 17.3313 18.2375 17.3313 18.4566 17.172C18.6477 17.033 18.7709 16.8194 18.7954 16.5844C18.8235 16.3149 18.6334 15.9866 18.2532 15.3299L11.3991 3.49109C11.0203 2.83679 10.8309 2.50964 10.5838 2.39976C10.3683 2.30392 10.1222 2.30392 9.90666 2.39976C9.65955 2.50964 9.47014 2.83679 9.09134 3.4911Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14570_89911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.245117 0.248047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.29585001dd45859883ba206d4574eab7.svg";
export { ForwardRef as ReactComponent };